export var CustomerChatFileVariant;
(function (CustomerChatFileVariant) {
    CustomerChatFileVariant["ORIGINAL"] = "ORIGINAL";
    CustomerChatFileVariant["PREVIEW"] = "PREVIEW";
})(CustomerChatFileVariant || (CustomerChatFileVariant = {}));
